import { useState } from "react";
import { Employee } from "../api/generated";
import { EmployeeRegisterStepOne } from "./employee_register_step_one";
import { MaterialIssueForm } from "./form/materialIssueForm";
import { DistributionMode } from "./form/distributionForm";

interface EmployeeMaterialActionStepperProps {
  title: string;
  secondStepName: string;
  mode: DistributionMode;
}

type StepNumber = 1 | 2;
type StepState = { number: 1 } | { number: 2; employee: Employee };

function canNavigateBack(current: StepNumber, target: StepNumber): boolean {
  return target < current;
}

function buildStateForStep(target: StepNumber, current: StepState): StepState {
  if (target === 1) {
    return { number: 1 };
  }

  if (!("employee" in current)) {
    return { number: 1 };
  }

  return { number: 2, employee: current.employee };
}

export const EmployeeMaterialActionStepper = (
  props: EmployeeMaterialActionStepperProps,
) => {
  const [state, setState] = useState<StepState>({ number: 1 });

  const steps = [
    { name: "Zoeken", number: 1 as StepNumber },
    { name: props.secondStepName, number: 2 as StepNumber },
  ];

  const goToStep = (target: StepNumber) => {
    if (!canNavigateBack(state.number, target)) {
      return;
    }

    setState(buildStateForStep(target, state));
  };

  return (
    <div className="flex justify-center items-center mt-10">
      <div className="flex w-3/4 flex-col items-center">
        <h1 className="text-2xl font-bold mb-4">{props.title}</h1>
        <ul className="steps">
          {steps.map((step) => (
            <li
              key={step.number}
              role="button"
              tabIndex={canNavigateBack(state.number, step.number) ? 0 : -1}
              onClick={() => goToStep(step.number)}
              className={`step ${step.number <= state.number ? "step-primary" : ""} ${
                canNavigateBack(state.number, step.number)
                  ? "cursor-pointer"
                  : "cursor-default"
              }`}
            >
              <span>{step.name}</span>
            </li>
          ))}
        </ul>

        {state.number === 1 && (
          <EmployeeRegisterStepOne
            onSelectEmployee={(employee) => setState({ number: 2, employee })}
          />
        )}

        {state.number === 2 && (
          <MaterialIssueForm
            employee={state.employee}
            mode={props.mode}
            onSave={() => setState({ number: 1 })}
          />
        )}
      </div>
    </div>
  );
};
